import React from "react";
import styled from "styled-components";
import Button from "./ActionButton";
import { useOutletContext } from "react-router";
import { persistUploadedImages } from "../../services/ProductImageService";
import { useRef } from "react";

const Container = styled.div`
  position: relative;

  input {
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    opacity: 0;
  }
`;

export default function UploadButton({
  $fullWidth,
  size,
  text,
  perform,
  productName,
  beforeUpload,
}) {
  const { user, token } = useOutletContext();
  const inputRef = useRef();

  const handleInputChange = async (e) => {
    if (beforeUpload && beforeUpload() === false) {
      // Reset input so user can select the same file again
      if (inputRef.current) inputRef.current.value = "";
      return;
    }
    const file = e.target.files[0];
    if (!file) {
      if (inputRef.current) inputRef.current.value = "";
      return;
    }
    try {
      const productImage = await persistUploadedImages(
        file,
        token,
        user.email,
        productName,
      );
      perform(productImage);
    } catch (err) {
      alert("Error uploading image: " + err.message);
    }
    // Reset input after upload
    if (inputRef.current) inputRef.current.value = "";
  };

  return (
    <Container className="flex">
      <Button
        $fullWidth={$fullWidth}
        size={size}
        text={text}
        action={() => {}}
        $NoBgColor
      />
      <input ref={inputRef} type="file" onChange={handleInputChange} />
    </Container>
  );
}
